<template>
    <div class="row cursor-pointer" @click="openBlogArticlePage">
        <div v-if="data" class="col-12 blog-card">

    <div v-if="data.image" class="mb-1 img-fluid" :class="{ graphic: size === 'lg' }">
        <img class="img-fluid" :src="data.image">
    </div>

    <div
    v-if="data.author_name || data.create_date"
    class="author-date"
>
    <span
        v-if="data.author_name"
        class="author-name font-manrope-medium fs--1 text-2"
    >
        {{ data.author_name }}
    </span>
    <div class="">
        <span
            v-if="data.author_name && data.create_date"
            class="dot"
        >
            •
        </span>

        <span
            v-if="data.create_date"
            class="blog-date font-manrope-medium fs--1 text-2"
        >
            {{ data.create_date }}
        </span>
    </div>
</div>

    <div class="content-area">
        <p class="text-primary bb-black"
           :class="{
               'fs-lg-4 mt-2 font-manrope-semi-bold': size === 'lg',
               'font-manrope-medium fs-lg-2': size === 'sm'
           }">
            {{ data.title }}
        </p>

        <p class="text-2 fs-lg-1">
            {{ data.title_description }}
        </p>
    </div>

    <div class="button-area fl-x">
        <!-- <p class="p-btn font-manrope-medium mr-2 mb-0">
            Cyber security
        </p>

        <p
            v-if="size === 'lg'"
            class="p-btn font-manrope-medium ml-2 mb-0"
        >
            Technology
        </p> -->

        <p
            v-if="data.category"
            class="p-btn-2 font-manrope-medium  mb-0"
        >
            {{ data.category }}
        </p>

        <btn
            @click.stop="openBlogArticlePage"
            design="basic-a"
            border-radius="4"
            size="sm"
            class="font-manrope-medium px-4"
        >
            view
        </btn>
    </div>

</div>

    </div>

</template>

<script>
export default {
    name: 'RecentBlogPost1',
    props: {
        data: {
            type: Object,
            default: null
        },
        size: {
            type: String,
            default: 'sm'
        }
    },
    methods: {
        openBlogArticlePage () {
            this.$router.push('/blog-article-article/' + this.data.id + '/details/');
        }
    }
};
</script>

<style scoped>
.graphic img {
    /*width: 55rem;*/
    /*height: 32rem;*/
    height: 25rem;
}

/*.h-6re {*/
/*    height: 6rem;*/
/*}*/
.blog-card {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.content-area {
    flex: 1;
}

.button-area {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: auto;
}

.text-primary {
    overflow-wrap: anywhere;
    word-break: break-word;
}

.text-2 {
    overflow-wrap: anywhere;
    word-break: break-word;
}
.p-btn {
    border: 1px solid black;
    border-radius: 16px;
    font-size: 0.85rem;
    color: #3D3F40;
    padding-left: 9px;
    padding-right: 9px;
    padding-top: 4px;
    padding-bottom: 6px;
}
.p-btn-2 {
    border: 1px solid black;
    border-radius: 16px;
    font-size: 0.85rem;
    color: #3D3F40;
    padding-left: 19px;
    padding-right: 19px;
    padding-top: 4px;
    padding-bottom: 4px;
}

@media screen and (max-width: 768px) {
    .graphic img {
        width: 100%;
        height: 80%;
    }
}
.author-date{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:8px;
    margin-bottom:10px;
    white-space:nowrap;
}

.author-name{
    overflow:hidden;
    text-overflow:ellipsis;
    justify-content: space-between;
    display:flex;
    align-items:center;
}

.blog-date{
    flex-shrink:0;
}

.dot{
    flex-shrink:0;
}
</style>
